export const currentValue = (predicate)=>{
    var _ref, _ref1, _ref2, _predicate_contains;
    return (_ref = (_ref1 = (_ref2 = (_predicate_contains = predicate.contains) !== null && _predicate_contains !== void 0 ? _predicate_contains : predicate.fuzzy) !== null && _ref2 !== void 0 ? _ref2 : predicate.exact) !== null && _ref1 !== void 0 ? _ref1 : predicate.startsWith) !== null && _ref !== void 0 ? _ref : '';
};
export const labelFromPredicate = (predicate, labels)=>{
    if (predicate.contains != null) return labels.contains(predicate.contains);
    if (predicate.fuzzy != null) return labels.fuzzy(predicate.fuzzy);
    if (predicate.exact != null) return labels.exact(predicate.exact);
    if (predicate.startsWith != null) return labels.startsWith(predicate.startsWith);
    return labels.empty();
};
export const nextPredicate = (input, previous)=>{
    if (previous.fuzzy != null) return {
        fuzzy: input
    };
    if (previous.exact != null) return {
        exact: input
    };
    if (previous.startsWith != null) return {
        startsWith: input
    };
    return {
        contains: input
    };
};
